<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mt-n2">{{$t("Classifier registrations")}}</h1>
        </v-flex>

        <v-flex xs12 class="mb-4">
          <v-layout row wrap>
          <v-btn class="ml-1 mt-4 mr-4" :loading="loading" color="primary" @click="loadClassifierRegistrations"><v-icon>search</v-icon>{{$t('Search')}}</v-btn>
          <v-flex grow></v-flex>
          <v-flex xs2 shrink><v-text-field class="ml-2" v-if="!isHide('ContainerNo')" v-model="containerNo" :label="$t('ContainerNo')"></v-text-field></v-flex>
          <v-flex xs2 shrink><v-text-field class="ml-2" v-if="!isHide('Container2No')" v-model="container2No" :label="$t('Container2No')"></v-text-field></v-flex>
          <v-flex xs2 shrink>
                <v-autocomplete v-if="!isHide('Vehicle')" class="ml-2" :items="vehicles" v-model="vehicleNo" @change="vehicleChanged" v-on:keyup="searchVehicle = $event.target.value" @keyup="searchDelayed" :label="$t('Vehicle')" @focus="focusVehicle"></v-autocomplete>
                <v-progress-linear v-if="searching" :indeterminate="true" class="mt-n6"></v-progress-linear>
          </v-flex>
          <v-flex xs2 shrink><v-select class="ml-2" hide-details="true" :items="statuses" v-model="statusNo" @change="statusChanged" :item-text="i => $t(i.text)" :label="$t('Status')"></v-select></v-flex>
          <v-flex xs2 shrink><v-select class="ml-2" hide-details="true" :items="facilitiesDisplay" v-model="facilityDisplay" @change="facilityChanged" :label="$t('Facility')"></v-select></v-flex>
          </v-layout>
          <v-row>
          </v-row>
        </v-flex>

        <!-- Classifier registrations -->
        <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        <v-flex xs12 v-else>
          <div v-if="registrations != null && registrations.length == 0" class="mt-4" style="text-align: center">{{$t("No classifier registrations found")}}</div>
          <template v-else v-for="clasReg in registrations">
            <div v-if="clasReg.FinishedBy == null && !clasReg.Completed" :key="clasReg.Id">
              <v-card raised class="mb-4">
                <v-layout row wrap>
                <v-flex xs12 md6>
                    <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
                      <v-flex d-flex xs8 style="padding-right: 6px">{{clasReg.Registration.ArticleNo}} - {{clasReg.Registration.ArticleName}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
                      <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(clasReg)}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('CreatedDate')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("CreatedDate")}}:</v-flex>
                      <v-flex d-flex xs8 style="padding-right: 6px">{{formatDate(clasReg.CreatedDate)}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('Status')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("Status")}}:</v-flex>
                      <v-flex d-flex xs8 class="font-weight-bold">{{getStatusStr(clasReg)}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
                      <v-flex d-flex xs8>{{clasReg.Registration.RequisitionNo1}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('SortMethod')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("Sorting method")}}:</v-flex>
                      <v-flex d-flex xs8 style="padding-right: 6px">{{$t(sortMethods.find(s => s.value == clasReg.SortMethod).text)}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('Minutes')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("Minutes")}}:</v-flex>
                      <v-flex d-flex xs8 style="padding-right: 6px">{{clasReg.MinutesUsed}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('ContainerNo')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("ContainerNo")}}:</v-flex>
                      <v-flex d-flex xs8>{{clasReg.Registration.ContainerNo}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('Container2No')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("Container2No")}}:</v-flex>
                      <v-flex d-flex xs8>{{clasReg.Registration.Container2No}}</v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                    <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
                      <v-flex d-flex xs8>{{clasReg.Facility}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("Vehicle")}}:</v-flex>
                      <v-flex d-flex xs8 class="font-weight-bold">{{clasReg.Registration.VehicleNo}} - {{clasReg.Registration.VehicleLicensePlateNo}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("ScanXRegNo")}}:</v-flex>
                      <v-flex d-flex xs8>{{clasReg.Registration.ScanXRegNo}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('DateFirst')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("DateFirst")}}:</v-flex>
                      <v-flex d-flex xs8>{{getDate(clasReg.Registration.DateFirst)}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('WeightGross')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("Weight")}}:</v-flex>
                      <v-flex d-flex xs8>{{getGrossWeightStr(clasReg)}}{{getMissingWeightStr(clasReg)}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('WeightNet')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("Net")}}:</v-flex>
                      <v-flex d-flex xs8>{{getNetWeightStr(clasReg)}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('RemainingArticleNo')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("RestArticleNo")}}:</v-flex>
                      <v-flex d-flex xs8>{{clasReg.RemainingArticleNo}}</v-flex>
                    </v-layout>
                    <v-layout v-if="!isHide('Comment')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4>{{$t("Comment")}}:</v-flex>
                      <v-flex d-flex xs8>{{clasReg.Registration.Comment1}}</v-flex>
                    </v-layout>
                </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-card-actions style="padding: 0px 0px 0px 0px" v-if="clasReg.FinishedBy == null && !clasReg.Completed">
                <v-flex xs12>
                    <v-btn v-if="showGotoDeliveryInspectionBtn" class="mr-1 mb-1"  @click="gotoDeliveryInspection(clasReg)" color="success">{{$t("Go to Delivery Inspection")}}</v-btn>
                </v-flex>
                <v-flex xs12 text-right>
                    <v-btn v-if="showAcceptBtn" class="mr-1 mb-1"  @click="approve(clasReg)" color="info">{{$t("Accept")}}</v-btn>
                    <v-btn class="mr-1 mb-1" :to="{name: 'edit-classifier-registration', params: {id: clasReg.Id, sortMethods: sortMethods, articles: articles, showAcceptBtn }}" color="primary">{{$t("Sort")}}</v-btn>
                </v-flex>
                </v-card-actions>
              </v-card>
            </div>
          </template>
        </v-flex>

        <!-- CONFIRM MISSING WEIGHT NOT 0 -->
        <v-dialog
          v-model="confirmMissingWeightDialog" max-width="400">
          <v-card>
            <v-card-title class="headline">{{$t("Missing sorting")}} {{MissingWeight}} kg</v-card-title>
            <!--template v-if="!showRecalc(storedApprovedReg)">
              <v-card-text>{{$t("FixSortingWeightDescription")}}</v-card-text>
            </template>
            <template v-else-->
            <template>
              <v-card-text>{{$t("MissingWeightDescription")}}</v-card-text>
              <v-card-text class="font-weight-bold">{{$t("MissingWeightRecalculation")}}</v-card-text>
            </template>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!--template v-if="!showRecalc(storedApprovedReg)"> // todo: Fix more elegant. See XNET-6936
                <v-btn color="success" @click="confirmMissingWeightDialog = false">{{$t("Ok")}}</v-btn>
              </template>
              <template v-else-->
              <template>
                <v-btn color="success" @click="confirmMissingWeightDialog = false; approvedReg = storedApprovedReg">{{$t("Yes")}}</v-btn>
                <v-btn color="primary" @click="confirmMissingWeightDialog = false">{{$t("No")}}</v-btn>
              </template>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import filters from '@/core/mixins/common-filters'
import * as Archive from '@/core/archive'
import * as LocalStorage from '@/core/local-storage'
import * as Classifier from '@/modules/classifier/classifier'
import formatDate from '@/core/mixins/formatDate'
import { UserDetail } from '@/core/userDetail'
import * as Security from '@/core/security'
import * as DateUtil from '@/core/date'
import { validSearchKeyUp } from '@/core/utils'
import _ from 'lodash' // clone

export default {
  mixins: [filters, formatDate],
  name: 'registrations',
  data () {
    return {
      loading: true,
      registrations: [],
      facilityNo: '',
      statusNo: '',
      statuses: [
        { value: '', text: '' },
        { value: '1', text: 'Unsorted' },
        { value: '2', text: 'Sorting in progress' }
      ],
      sortMethods: [
        { value: 1, text: 'ManInMachine' },
        { value: 2, text: 'ManInMachinePlusOneMan' },
        { value: 3, text: 'HandsortOneMan' },
        { value: 4, text: 'HandsortTwoMen' }
      ],
      articles: [],
      vehicles: [],
      vehicleNo: null,
      searchVehicle: '',
      searching: false,
      searchTimer: null,
      containerNo: null,
      container2No: null,
      facilities: null,
      facilitiesDescription: [],
      facilityDescription: '',
      useFacilityDescription: false,
      facilityDisplay: '',
      facilitiesDisplay: [],
      returnTo: 'classifier-registrations',
      showAcceptBtn: true,
      showGotoDeliveryInspectionBtn: false,
      redirectToInspection: 'inspection',
      MissingWeight: 0,
      approvedReg: null,
      storedApprovedReg: null,
      confirmMissingWeightDialog: false
    }
  },
  watch: {
    approvedReg: {
      async handler () {
        this.approvedReg.Registration.ExtraDataNo = 3
        const res = await Classifier.approveRegistration(this.approvedReg)
        if (!res.failed) {
          this.$root.$message.showSuccess(this.$t('Approved'))
          this.loadClassifierRegistrations()
        } else {
          console.log('approveRegistration fail', this.approvedReg, res)
        }
      }
    }
  },
  methods: {
    async gotoDeliveryInspection (clasReg) {
      const res = await Classifier.loadDeliveryInspectionRegistration({ Facility: this.facilityNo, RegistrationNo: clasReg.Registration.ScanXRegNo })
      if (!res.failed && res.data && res.data.Id !== '00000000-0000-0000-0000-000000000000') {
        this.$router.push({ name: this.redirectToInspection, params: { id: res.data.Id } })
      } else {
        this.$root.$message.showError(this.$t('No Delivery Inspection found'))
      }
    },
    showRecalc (val) {
      // Only show Recalc message when WeightNet = 0
      return (val?.Registration?.WeightNet ?? 0) === 0
    },
    searchDelayed (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchVehicles, 300)
      }
    },
    searchVehicles () {
      if (this.searchVehicle.length < 1) {
        this.vehicles = []
        this.vehicleNo = null
      }
      // Temporary show Search vehicle xxx ....
      this.vehicles = [this.searchVehicle.length ? this.$t('Searching') + ' ' + this.searchVehicle + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchVehicle) this.updateVehicles(this.searchVehicle)
    },
    async vehicleChanged () {
      // Fix selecting "Search" by accident
      if ((!this.vehicleNo && this.vehicles.length !== 1) || (this.vehicleNo && this.vehicleNo.includes(this.$t('Search')))) {
        this.vehicles = []
        this.vehicleNo = ''
        this.searchVehicle = ''
      }
    },
    focusVehicle () {
      // Temporary show Search
      if (this.vehicles.length !== 1) this.vehicles = [this.$t('Search')]
    },
    async updateVehicles (search) {
      this.searching = true

      // "search" for one vehicle (single lookup)
      if (search.length === 1) {
        const res = await Archive.loadVehicle({ facilityNo: this.facilityNo, vehicleNo: search })
        if (!res.failed) {
          if (res.data) {
            const item = res.data
            this.vehicles = [{
              text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
              value: item.No,
              obj: item
            }]
          } else {
            this.vehicles = []
          }
        }
      } else { // search for many vehicles (via searchText)
        const res = await Archive.loadVehicles({ facility: this.facilityNo, searchText: search })
        if (!res.failed) {
          this.vehicles = res.data.map(item => {
            return {
              text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
              value: item.No,
              obj: item
            }
          })
        }
      }

      this.searching = false
    },
    async loadVehicle (search) {
      const res = await Archive.loadVehicle({ facilityNo: this.facilityNo, vehicleNo: search })
      if (!res.failed) {
        if (res.data) {
          const item = res.data
          this.vehicles = [{
            text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }]
        }
      }
    },
    async approve (clasReg) {
      // RefreshWeight
      const res = await Classifier.loadRegistration(clasReg.Id)
      if (!res.failed) {
        const newComments = clasReg.Registration.Comment1 // Save Comment1
        clasReg.Registration = res.data.Registration // only update Registration (not ClassifierRegistration)
        clasReg.Registration.Comment1 = newComments // Reset Comment1
        this.recalc(clasReg)
      } // data not a list

      // Add positive MissingWeight value to RemainingArticleNo
      if (clasReg.MissingWeight > 0 && clasReg.RemainingArticleNo) {
        var addToArticle = clasReg.Articles.find(a => a.No === clasReg.RemainingArticleNo)
        if (addToArticle) {
          addToArticle.Amount += clasReg.MissingWeight
          this.recalc(clasReg)
        }
      }

      this.MissingWeight = clasReg.MissingWeight
      this.storedApprovedReg = clasReg
      // if MissingWeight = 0 just approve, else ask user in confirmMissingWeightDialog
      if (this.MissingWeight === 0) { this.approvedReg = clasReg } else { this.confirmMissingWeightDialog = true }
    },
    async loadClassifierRegistrations () {
      this.loading = true
      this.registrations = []
      const res = await Classifier.loadRegistrations({ facility: this.facilityNo, status: this.statusNo })
      if (!res.failed) {
        this.registrations = res.data

        // Extra filters on containerNo, container2No or vehicleNo
        if (this.containerNo) this.registrations = this.registrations.filter(r => r.Registration.ContainerNo === this.containerNo)
        if (this.container2No) this.registrations = this.registrations.filter(r => r.Registration.Container2No === this.container2No)
        if (this.vehicleNo) this.registrations = this.registrations.filter(r => r.Registration.VehicleNo === this.vehicleNo)
      }
      this.loading = false
    },
    async loadGroupedArticles () {
      const res = await Classifier.loadGroupedArticles(this.facilityNo)
      if (!res.failed) {
        const groupedArticles = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item,
            groupNo: item.Details.find(d => d.Name === 'GroupNo')?.Value ?? null,
            unit: item.Details.find(d => d.Name === 'Unit')?.Value ?? null,
            no: item.No,
            name: item.Name
          }
        })
        this.articles = groupedArticles.filter(g => g.groupNo)
        if (!this.articles) this.$root.$message.showError(this.$t('Articles with GroupNo not found'))
      }
    },
    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
        if (facilityDisplay != null) {
          this.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.facilityNo = this.facilityDisplay
      }
      this.loading = true
      if (this.facilityNo != null) LocalStorage.save('facilityNo', this.facilityNo)
      this.loadGroupedArticles()
      this.loadClassifierRegistrations()
      this.vehicleNo = null
    },
    async statusChanged () {
      this.loading = true
      this.loadClassifierRegistrations()
      LocalStorage.save('statusNo', this.statusNo)
    },
    getDate (date) {
      return DateUtil.getSmartDate(date)
    },
    getCustomerStr (clasReg) {
      if (clasReg.Registration.CustomerNo && clasReg.Registration.CustomerName) {
        return clasReg.Registration.CustomerNo + ' - ' + clasReg.Registration.CustomerName
      } else if (clasReg.Registration.CustomerNo) {
        return clasReg.Registration.CustomerNo
      } else if (clasReg.Registration.CustomerName) {
        return clasReg.Registration.CustomerName
      } else { return '' }
    },
    recalc (clasReg) {
      clasReg.GrossWeight = 0
      clasReg.DeductionWeight = 0
      clasReg.Articles.forEach(item => {
        if (item.Unit === 'Kg' && item.ArticleGroup !== '10') clasReg.GrossWeight += Math.abs((item.Amount))
        if (item.Unit === 'Kg' && item.ArticleGroup === '10') clasReg.DeductionWeight += Math.abs((item.Amount))
      })
      clasReg.NetWeight = Math.abs(clasReg.GrossWeight) - Math.abs(clasReg.DeductionWeight)
      clasReg.MissingWeight = Math.abs(clasReg.Registration.WeightNet) - Math.abs(clasReg.GrossWeight + clasReg.DeductionWeight)
    },
    getGrossWeightStr (clasReg) {
      this.recalc(clasReg)
      return Math.abs(clasReg.Registration.WeightNet) + ' kg'
    },
    getNetWeightStr (clasReg) {
      return clasReg.NetWeight + ' kg'
    },
    getMissingWeightStr (clasReg) {
      return clasReg.Registration.WeightNet !== clasReg.MissingWeight ? ' (' + clasReg.MissingWeight + ' kg)' : ''
    },
    getStatusStr (clasReg) {
      return this.$t(this.statuses.find(s => s.value === clasReg.Registration.ExtraDataNo)?.text ?? '')
    },
    isHide (fieldName) {
      return false // Show all. In the future, this can load from Settings
    }
  },
  async mounted () {
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    // Load Facilities
    const facilitiesRes = await Archive.loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      // Let user select no facilities (= show data from all allowed facilities)
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
      this.facilitiesDisplay = this.facilities
      if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
        var d = facilitiesResDescription.data
        if (!d.includes('')) d.unshift({ No: '', Description: '' })
        this.facilitiesDescription = d.map(item => {
          return {
            text: item.Description,
            value: item.Description,
            item: item
          }
        })

        this.facilitiesDisplay = this.facilitiesDescription
      }
    }

    // Load current (stored) facilityNo
    const storedFacilityNo = '' + LocalStorage.load('facilityNo')
    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) this.facilityNo = storedFacilityNo
    else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }

    if (this.useFacilityDescription) {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } else {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilities.find(f => f.item.No === this.facilityNo).value
    }

    // Load current (stored) statusNo
    const statusNo = LocalStorage.load('statusNo')
    if (statusNo) this.statusNo = statusNo.toString()
    else { this.statusNo = ''; LocalStorage.remove('statusNo') }

    // Load grouped Articles
    this.loadGroupedArticles()

    // Load active Classifier registrations
    this.loadClassifierRegistrations()

    // Hide (Disable) Accept button, if setup on User
    const disableApprovalRightsDetail = await UserDetail.load(Security.user.id, 'DisableApprovalRights')
    if (disableApprovalRightsDetail) this.showAcceptBtn = !(disableApprovalRightsDetail.Value === 'true')

    // Hide  button, if setup on User
    const showGotoDeliveryInspectionDetail = await UserDetail.load(Security.user.id, 'ShowGotoDeliveryInspection')
    if (showGotoDeliveryInspectionDetail && showGotoDeliveryInspectionDetail.Value) this.showGotoDeliveryInspectionBtn = (showGotoDeliveryInspectionDetail.Value === 'true')
  }
}
</script>

<style>
</style>
